export const ADD_APP_CONFIG = 'ADD_APP_CONFIG';

export function addAppConfig(appConfig) {
  return { appConfig, type: ADD_APP_CONFIG };
}
